/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AdminIndexRouteImport } from './routes/admin.index'
import { Route as AdminAddRouteImport } from './routes/admin.add'
import { Route as AdminDeletedRouteImport } from './routes/admin.deleted'
import { Route as AdminLibraryRouteImport } from './routes/admin.library'
import { Route as AdminRequestsRouteImport } from './routes/admin.requests'
import { Route as AdminSoundsRouteImport } from './routes/admin.sounds'
import { Route as AdminTaxonomyRouteImport } from './routes/admin.taxonomy'
import { Route as GameSlugRouteImport } from './routes/game.$slug'
import { Route as AdminGameIdRouteImport } from './routes/admin.game.$id'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminAddRoute = AdminAddRouteImport.update({
  id: '/add',
  path: '/add',
  getParentRoute: () => AdminRoute,
} as any)
const AdminDeletedRoute = AdminDeletedRouteImport.update({
  id: '/deleted',
  path: '/deleted',
  getParentRoute: () => AdminRoute,
} as any)
const AdminLibraryRoute = AdminLibraryRouteImport.update({
  id: '/library',
  path: '/library',
  getParentRoute: () => AdminRoute,
} as any)
const AdminRequestsRoute = AdminRequestsRouteImport.update({
  id: '/requests',
  path: '/requests',
  getParentRoute: () => AdminRoute,
} as any)
const AdminSoundsRoute = AdminSoundsRouteImport.update({
  id: '/sounds',
  path: '/sounds',
  getParentRoute: () => AdminRoute,
} as any)
const AdminTaxonomyRoute = AdminTaxonomyRouteImport.update({
  id: '/taxonomy',
  path: '/taxonomy',
  getParentRoute: () => AdminRoute,
} as any)
const GameSlugRoute = GameSlugRouteImport.update({
  id: '/game/$slug',
  path: '/game/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminGameIdRoute = AdminGameIdRouteImport.update({
  id: '/game/$id',
  path: '/game/$id',
  getParentRoute: () => AdminRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteWithChildren
  '/login': typeof LoginRoute
  '/admin/add': typeof AdminAddRoute
  '/admin/deleted': typeof AdminDeletedRoute
  '/admin/library': typeof AdminLibraryRoute
  '/admin/requests': typeof AdminRequestsRoute
  '/admin/sounds': typeof AdminSoundsRoute
  '/admin/taxonomy': typeof AdminTaxonomyRoute
  '/game/$slug': typeof GameSlugRoute
  '/admin/': typeof AdminIndexRoute
  '/admin/game/$id': typeof AdminGameIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/admin/add': typeof AdminAddRoute
  '/admin/deleted': typeof AdminDeletedRoute
  '/admin/library': typeof AdminLibraryRoute
  '/admin/requests': typeof AdminRequestsRoute
  '/admin/sounds': typeof AdminSoundsRoute
  '/admin/taxonomy': typeof AdminTaxonomyRoute
  '/game/$slug': typeof GameSlugRoute
  '/admin': typeof AdminIndexRoute
  '/admin/game/$id': typeof AdminGameIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteWithChildren
  '/login': typeof LoginRoute
  '/admin/add': typeof AdminAddRoute
  '/admin/deleted': typeof AdminDeletedRoute
  '/admin/library': typeof AdminLibraryRoute
  '/admin/requests': typeof AdminRequestsRoute
  '/admin/sounds': typeof AdminSoundsRoute
  '/admin/taxonomy': typeof AdminTaxonomyRoute
  '/game/$slug': typeof GameSlugRoute
  '/admin/': typeof AdminIndexRoute
  '/admin/game/$id': typeof AdminGameIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/login'
    | '/admin/add'
    | '/admin/deleted'
    | '/admin/library'
    | '/admin/requests'
    | '/admin/sounds'
    | '/admin/taxonomy'
    | '/game/$slug'
    | '/admin/'
    | '/admin/game/$id'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/admin/add'
    | '/admin/deleted'
    | '/admin/library'
    | '/admin/requests'
    | '/admin/sounds'
    | '/admin/taxonomy'
    | '/game/$slug'
    | '/admin'
    | '/admin/game/$id'
  id:
    | '__root__'
    | '/'
    | '/admin'
    | '/login'
    | '/admin/add'
    | '/admin/deleted'
    | '/admin/library'
    | '/admin/requests'
    | '/admin/sounds'
    | '/admin/taxonomy'
    | '/game/$slug'
    | '/admin/'
    | '/admin/game/$id'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRoute: typeof AdminRouteWithChildren
  LoginRoute: typeof LoginRoute
  GameSlugRoute: typeof GameSlugRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/': {
      id: '/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/add': {
      id: '/admin/add'
      path: '/add'
      fullPath: '/admin/add'
      preLoaderRoute: typeof AdminAddRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/deleted': {
      id: '/admin/deleted'
      path: '/deleted'
      fullPath: '/admin/deleted'
      preLoaderRoute: typeof AdminDeletedRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/library': {
      id: '/admin/library'
      path: '/library'
      fullPath: '/admin/library'
      preLoaderRoute: typeof AdminLibraryRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/requests': {
      id: '/admin/requests'
      path: '/requests'
      fullPath: '/admin/requests'
      preLoaderRoute: typeof AdminRequestsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/sounds': {
      id: '/admin/sounds'
      path: '/sounds'
      fullPath: '/admin/sounds'
      preLoaderRoute: typeof AdminSoundsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/taxonomy': {
      id: '/admin/taxonomy'
      path: '/taxonomy'
      fullPath: '/admin/taxonomy'
      preLoaderRoute: typeof AdminTaxonomyRouteImport
      parentRoute: typeof AdminRoute
    }
    '/game/$slug': {
      id: '/game/$slug'
      path: '/game/$slug'
      fullPath: '/game/$slug'
      preLoaderRoute: typeof GameSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/game/$id': {
      id: '/admin/game/$id'
      path: '/game/$id'
      fullPath: '/admin/game/$id'
      preLoaderRoute: typeof AdminGameIdRouteImport
      parentRoute: typeof AdminRoute
    }
  }
}

interface AdminRouteChildren {
  AdminAddRoute: typeof AdminAddRoute
  AdminDeletedRoute: typeof AdminDeletedRoute
  AdminLibraryRoute: typeof AdminLibraryRoute
  AdminRequestsRoute: typeof AdminRequestsRoute
  AdminSoundsRoute: typeof AdminSoundsRoute
  AdminTaxonomyRoute: typeof AdminTaxonomyRoute
  AdminIndexRoute: typeof AdminIndexRoute
  AdminGameIdRoute: typeof AdminGameIdRoute
}

const AdminRouteChildren: AdminRouteChildren = {
  AdminAddRoute: AdminAddRoute,
  AdminDeletedRoute: AdminDeletedRoute,
  AdminLibraryRoute: AdminLibraryRoute,
  AdminRequestsRoute: AdminRequestsRoute,
  AdminSoundsRoute: AdminSoundsRoute,
  AdminTaxonomyRoute: AdminTaxonomyRoute,
  AdminIndexRoute: AdminIndexRoute,
  AdminGameIdRoute: AdminGameIdRoute,
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRoute: AdminRouteWithChildren,
  LoginRoute: LoginRoute,
  GameSlugRoute: GameSlugRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
